import {ApiService} from '../api';

// Null when the currencies differ and no valid rate is available, so callers can refuse to convert
export const getExchangeRateOrNull = async (
  sourceCurrency: string,
  targetCurrency: string,
  measurementDateId: string,
  currencyDate?: string
): Promise<string | null> => {
  if (sourceCurrency === targetCurrency) {
    return '1';
  }
  // Implement the financials --> cap table currency conversion
  const currencies = `$${targetCurrency}${sourceCurrency}:`;
  const response = await ApiService.apiValuationGetExchangeRateRead(measurementDateId, currencies, currencyDate)

  if (response?.valid_exchange_data) {
    return response?.exchange_rate?.close_price?.value ?? null;
  }

  return null;
};

const getExchangeRate = async (
  sourceCurrency: string,
  targetCurrency: string,
  measurementDateId: string,
  currencyDate?: string
): Promise<string> => {
  // Default value if sourceCurrency is the same as targetCurrency or no rate is available
  const exchangeRate = await getExchangeRateOrNull(sourceCurrency, targetCurrency, measurementDateId, currencyDate);
  return exchangeRate ?? '1';
};

export default getExchangeRate;
